import { CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const RefetchingIndicator = () => {
    const theme = useTheme();
    return (
        <CircularProgress
            size={24}
            sx={{
                color: theme.palette.customColors.purple,
                position: 'absolute',
                bottom: theme.spacing(2),
                right: theme.spacing(4),
            }}
        />
    );
};
